/* global HTMLElement, window, document */

export default class Numbers extends HTMLElement {

	constructor() {
		super();

		/**
		 * some selector variables
		 */
		this.selectorNumbersHidden = 'nm-number-hidden';
		this.showNumbersHandler = null;
	}

	connectedCallback() {
		this._initializeModule();
	}

	disconnectedCallback() {
		window.removeEventListener("scroll", this.showNumbersHandler);
	}

	/**
	 * initialize elements
	 * @returns {undefined}
	 */
	_initializeModule() {
		if(this.classList.contains(this.selectorNumbersHidden)) {
			this._handleShowNumbers();
			this.showNumbersHandler = this._handleShowNumbers.bind(this);
			window.addEventListener("scroll", this.showNumbersHandler);
		}
	}

	/**
	 * private function handling the visibility of the numbers
	 * @returns {undefined}
	 */
	_handleShowNumbers() {
		if(this.classList.contains(this.selectorNumbersHidden) && this._getVisibleVerticalPercentageInViewport() >= 25) {
			this.classList.remove(this.selectorNumbersHidden);
			window.removeEventListener("scroll", this.showNumbersHandler);
		}
	}
	/**
	* @description get the visible vertical percentage of an element in the viewport
	* @returns {number}
	*/
	/* NOTE: this is a copy of Nemo DomUtils.getVisibleVerticalPercentageInViewport() */
	_getVisibleVerticalPercentageInViewport() {
		let rect = this.getBoundingClientRect();
		let pixelVisible = window.innerHeight - rect.top;

		if (rect.top < 0) {
			pixelVisible = rect.bottom;
		}
		if (pixelVisible <= 0) {
			return 0;
		}
		if (pixelVisible >= rect.height) {
			return 100;
		}
		return (pixelVisible / rect.height) * 100;
	}
}

if (window.customElements.get('audi-numbers') === undefined) {
	window.customElements.define('audi-numbers', Numbers);
}
